import { render, staticRenderFns } from "./LayoutContentStaInfor.vue?vue&type=template&id=13cc779f&scoped=true"
import script from "./LayoutContentStaInfor.vue?vue&type=script&lang=js"
export * from "./LayoutContentStaInfor.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentStaInfor.vue?vue&type=style&index=0&id=13cc779f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc779f",
  null
  
)

export default component.exports